/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    declare var emailSystemActionSelf: EmailSystemActionsModel;

    export class EmailSystemActionsModel {
        private logType: string = "EmailSystemActionsModel";

        private systemLevel: Wars.Domain.Model.SystemLevel;
        public emailConfigurations: Array<Wars.Domain.Model.EmailConfiguration>;
        public selectedEmailConfiguration: Wars.Domain.Model.EmailConfiguration;
        public isEditing: boolean;
        public editingNew: boolean;
        public showTinyMce: boolean;
        public editingExisting: boolean;
        public showAttachments: boolean;
        public showCarbonCopy: boolean;
        public showBlindCarbonCopy: boolean;
        public disableReceipientValue: boolean;
        public tinyMceOptions: any;
        public subjectTinyMceOptions: any;
        public currentWarsData: any;
        public currentTreeItem: models.TreeConfigurationItem;
        public processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        public documentTags: any;
        public recipientTags: any;
        public recipient: any;
        public carbonCopyTags: any;
        public carbonCopy: any;
        public blindCarbonCopiesTags: any;
        public blindCarbonCopy: any;
        public staticDocuments: Array<Wars.Domain.Model.StaticDocument>;
        public isSystemLevel: boolean;
        private modalService: any;
        public pages: Wars.Domain.Model.Dtos.ContentPageDto[];
        public activeProcessTypes: Wars.Domain.Model.ProcessType[];

        constructor(
            private scope: angular.IScope,
            private growlService: angular.growl.IGrowlService,
            private processConfigurationId: string,
            private processConfigurationService: services.ProcessConfigurationService,
            private treeService: services.TreeService,
            private treeItemService: services.TreeItemService,
            private manageStaticDocumentsService: services.ManageStaticDocumentsService,
            private systemLevelService: services.SystemLevelService,
            private emailConfigurationService: services.EmailConfigurationService,
            private deleteService: services.DeleteService,
            private contentPageService: warsApp.services.ContentPageService,
            private processTypeService: services.ProcessTypeService,
            private formService: services.FormService,
            modalService: any
        ) {
            (<any>scope).getSelectedNode = function (data: models.TreeConfigurationItem) {
                console.info(data);
                emailSystemActionSelf.currentTreeItem = data;
            }

            emailSystemActionSelf = this;
            emailSystemActionSelf.showTinyMce = false;
            emailSystemActionSelf.showAttachments = true;
            emailSystemActionSelf.showCarbonCopy = true;
            emailSystemActionSelf.showBlindCarbonCopy = true;
            emailSystemActionSelf.disableReceipientValue = false;
            emailSystemActionSelf.modalService = modalService;
            emailSystemActionSelf.contentPageService = contentPageService;

            emailSystemActionSelf.contentPageService.getContentPagesForConfiguration()
                .then(pages => {
                    emailSystemActionSelf.pages = pages;
                });

            emailSystemActionSelf.processTypeService.getActiveProcessTypes().then(result => {
                emailSystemActionSelf.activeProcessTypes = result;
            });

            if (emailSystemActionSelf.processConfigurationId) {
                formService.getProcessConfigurationContainers(emailSystemActionSelf.processConfigurationId).then((processContainers) => {
                    var forms = [];
                    processContainers.forEach(f => {
                        var form = {
                            title: f.name,
                            value: '{{GetBaseUrl}}/#/Process/{{ProcessId}}/Form/' + f.uniqueIdentifier
                        }
                        forms.push(form);
                    });

                    manageStaticDocumentsService.getStaticDocumentsForProcessConfiguration(this.processConfigurationId).then(d => {
                        emailSystemActionSelf.showTinyMce = true;
                        emailSystemActionSelf.staticDocuments = d;
                        emailSystemActionSelf.isSystemLevel = false;

                        var images = [];
                        emailSystemActionSelf.staticDocuments.forEach(i => {
                            var image = {
                                title: i.fileName,
                                value: '{{GetBaseUrl}}/api/Document/StaticDocument/' + i.id
                            }
                            images.push(image);
                        });

                        this.tinyMceOptions = {
                            format: 'raw',
                            menubar: false,
                            height: 500,
                            plugins: "noneditable, link, image, imagetools, preview, code",
                            imagetools_toolbar: "rotateleft rotateright | flipv fliph | editimage imageoptions",
                            content_css: "content/mce.css",
                            toolbar1: 'insertfield | addlink | destinationLink | undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link | image | preview | code',
                            //relative_urls: false,
                            //remove_script_host: false,
                            //document_base_url: localStorage.getItem('baseUrl'),
                            image_list: images,
                            link_list: forms,
                            external_image_list_url: images,
                            setup: function (editor) {
                                editor.addButton('insertfield', {
                                    text: 'Insert Field',
                                    icon: false,
                                    onclick: function () {
                                        if (!emailSystemActionSelf.currentTreeItem) {
                                            emailSystemActionSelf.growlService.error('A field must be selected on the tree before you can insert a field.');
                                        } else {
                                            var treeItem = emailSystemActionSelf.treeService.createTreeItemFromConfig(emailSystemActionSelf.currentTreeItem, () => {
                                                treeItem.emailBinding = emailSystemActionSelf.selectedEmailConfiguration;
                                                emailSystemActionSelf.selectedEmailConfiguration.bindings.push(treeItem);
                                                emailSystemActionSelf.saveChanges(() => {
                                                    editor.insertContent("<span class='mceNonEditable fieldBind' data-TreeId=" + treeItem.id + ">" + emailSystemActionSelf.treeService.getDisplayName(treeItem) + "</span>");
                                                });
                                            });
                                        }
                                    }
                                });

                                editor.addButton('addlink', {
                                    text: 'Link to Page',
                                    type: 'menubutton',
                                    icon: false,
                                    menu: [
                                        {
                                            text: 'Link to Static Page',
                                            onclick: function () {
                                                emailSystemActionSelf.modalService.showModal({
                                                    templateUrl: "./app/views/modals/contentPageStaticLinkModal.html",
                                                    controller: "contentPageStaticLinkModalController",
                                                    inputs: {
                                                        contentPages: emailSystemActionSelf.pages
                                                    }
                                                }).then(modal => {
                                                    // The modal object has the element built, if this is a bootstrap modal
                                                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                                                    // it as you need to.                
                                                    modal.element.modal();
                                                    modal.close.then(result => {
                                                        if (result) {
                                                            editor.insertContent('<a href="{{GetBaseUrl}}/#/ContentPage/' + result.id + '">Link to ' + result.title + '</a>');
                                                        }
                                                    });
                                                });
                                            }
                                        },
                                        {
                                            text: 'Link to Process', //Link to New Process
                                            onclick: function () {
                                                editor.insertContent('<a href="{{GetBaseUrl}}/#/ProcessType/' + emailSystemActionSelf.processConfiguration.processType_id + '/Process/">Link to Process</a>'); //Link to New Process
                                            }
                                        },
                                        {
                                            text: 'Link to Home Page',
                                            onclick: function () {
                                                editor.insertContent('<a href="{{GetBaseUrl}}/#/Home">Link to Home Page</a>');
                                            }
                                        }
                                    ]
                                });

                                editor.addButton('destinationLink', {
                                    text: 'Future Status/State',
                                    type: 'menubutton',
                                    icon: false,
                                    menu: [
                                        {
                                            text: 'Destination Status',
                                            onclick() {
                                                editor.insertContent('{{DestinationStatus}}');
                                            }
                                        },
                                        {
                                            text: 'Destination State',
                                            onclick() {
                                                editor.insertContent('{{DestinationState}}');
                                            }
                                        }
                                    ]
                                });

                                services.WarsLogger.logDebug("Editor Object", this.logType, editor);
                            }
                        };
                    });
                });

                processConfigurationService.getProcessConfigurationExpandFieldsAndEmailConfigs(processConfigurationId).then(
                    (appConfig) => {
                        this.processConfiguration = appConfig;
                    });
                emailConfigurationService.getAllEmailConfigurationsByProcessId(processConfigurationId).then(
                    (emailConfigs) => {
                        this.emailConfigurations = emailConfigs;
                    });
            } else {
                systemLevelService.getSystemLevelFormContainerAssociations().then(
                    (systemLevel) => {
                        var forms = [];
                        systemLevel.myFormContainerAssociations.forEach(f => {
                            var form = {
                                title: f.name,
                                value: '{{GetBaseUrl}}/#/Process/{{ProcessId}}/{{FormContainerAssociationId}}/' + f.id
                            }
                            forms.push(form);
                        });

                        systemLevelService.getSystemLevelStaticDocuments().then(
                            (systemLevel) => {
                                emailSystemActionSelf.systemLevel = systemLevel;
                                emailSystemActionSelf.showTinyMce = true;
                                emailSystemActionSelf.staticDocuments = systemLevel.myStaticDocuments;
                                emailSystemActionSelf.isSystemLevel = true;

                                var images = [];
                                emailSystemActionSelf.staticDocuments.forEach(i => {
                                    var image = {
                                        title: i.fileName,
                                        value: '{{GetBaseUrl}}/api/Document/StaticDocument/' + i.id
                                    }
                                    images.push(image);
                                });

                                this.tinyMceOptions = {
                                    format: 'raw',
                                    menubar: false,
                                    height: 500,
                                    plugins: "noneditable, link, image, imagetools, preview, code",
                                    imagetools_toolbar: "rotateleft rotateright | flipv fliph | editimage imageoptions",
                                    content_css: "content/mce.css",
                                    toolbar1: 'insertfield | addlink | destinationLink | undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link | image | preview | code',
                                    //relative_urls: false,
                                    //remove_script_host: false,
                                    //document_base_url: localStorage.getItem('baseUrl'),
                                    link_list: forms,
                                    image_list: images,
                                    external_image_list_url: images,
                                    setup: function (editor) {
                                        editor.addButton('insertfield', {
                                            text: 'Insert Field',
                                            icon: false,
                                            onclick: function () {
                                                if (!emailSystemActionSelf.currentTreeItem) {
                                                    emailSystemActionSelf.growlService.error('A field must be selected on the tree before you can insert a field.');
                                                } else {
                                                    var treeItem = emailSystemActionSelf.treeService.createTreeItemFromConfig(emailSystemActionSelf.currentTreeItem, () => {
                                                        treeItem.emailBinding = emailSystemActionSelf.selectedEmailConfiguration;
                                                        emailSystemActionSelf.selectedEmailConfiguration.bindings.push(treeItem);
                                                        emailSystemActionSelf.saveChanges(() => {
                                                            editor.insertContent("<span class='mceNonEditable fieldBind' data-TreeId=" + treeItem.id + ">" + emailSystemActionSelf.treeService.getDisplayName(treeItem) + "</span>");
                                                        });
                                                    });
                                                }
                                            }
                                        });

                                        editor.addButton('addlink', {
                                            text: 'Link to Page',
                                            type: 'menubutton',
                                            icon: false,
                                            menu: [
                                                {
                                                    text: 'Link to Static Page',
                                                    onclick: function () {
                                                        emailSystemActionSelf.modalService.showModal({
                                                            templateUrl: "./app/views/modals/contentPageStaticLinkModal.html",
                                                            controller: "contentPageStaticLinkModalController",
                                                            inputs: {
                                                                contentPages: emailSystemActionSelf.pages
                                                            }
                                                        }).then(modal => {
                                                            // The modal object has the element built, if this is a bootstrap modal
                                                            // you can call 'modal' to show it, if it's a custom modal just show or hide
                                                            // it as you need to.                
                                                            modal.element.modal();
                                                            modal.close.then(result => {
                                                                if (result) {
                                                                    editor.insertContent('<a href="{{GetBaseUrl}}/#/ContentPage/' + result.id + '">Link to ' + result.title + '</a>');
                                                                }
                                                            });
                                                        });
                                                    }
                                                },
                                                {
                                                    text: 'Link to Process',
                                                    onclick: function () {
                                                        emailSystemActionSelf.modalService.showModal({
                                                            templateUrl: "./app/views/modals/contentPageProcessLinkModal.html",
                                                            controller: "contentPageProcessLinkModalController",
                                                            inputs: {
                                                                activeProcessTypes: emailSystemActionSelf.activeProcessTypes
                                                            }
                                                        }).then(modal => {
                                                            // The modal object has the element built, if this is a bootstrap modal
                                                            // you can call 'modal' to show it, if it's a custom modal just show or hide
                                                            // it as you need to.                
                                                            modal.element.modal();
                                                            modal.close.then(result => {
                                                                if (result) {
                                                                    editor.insertContent('<a href="{{GetBaseUrl}}/#/ProcessType/' + result.id + '/Process">Link to ' + result.name + '</a>');
                                                                }
                                                            });
                                                        });
                                                    }
                                                },
                                                {
                                                    text: 'Link to Home Page',
                                                    onclick: function () {
                                                        editor.insertContent('<a href="{{GetBaseUrl}}/#/Home">Link to Home Page</a>');
                                                    }
                                                }
                                            ]
                                        });

                                        editor.addButton('destinationLink', {
                                            text: 'Future Status/State',
                                            type: 'menubutton',
                                            icon: false,
                                            menu: [
                                                {
                                                    text: 'Destination Status',
                                                    onclick() {
                                                        editor.insertContent('{{DestinationStatus}}');
                                                    }
                                                },
                                                {
                                                    text: 'Destination State',
                                                    onclick() {
                                                        editor.insertContent('{{DestinationState}}');
                                                    }
                                                }
                                            ]
                                        });

                                        services.WarsLogger.logDebug("Editor Object", this.logType, editor);
                                    }
                                };
                            });
                    });

                systemLevelService.getSystemEmailConfigurations().then(
                    (systemLevel) => {
                        this.systemLevel = systemLevel;
                        this.emailConfigurations = systemLevel.myEmailConfigurations;
                    });
            }

            this.subjectTinyMceOptions = {
                format: 'raw',
                menubar: false,
                height: 25,
                plugins: "noneditable, preview, code",
                content_css: "content/mce.css",
                toolbar1: 'insertfield | destinationLink | undo redo | preview | code',
                charLimit: 512,
                setup: function (editor) {
                    editor.addButton('insertfield', {
                        text: 'Insert Field',
                        icon: false,
                        onclick: function () {
                            if (!emailSystemActionSelf.currentTreeItem) {
                                emailSystemActionSelf.growlService.error('A field must be selected on the tree before you can insert a field.');
                            } else {
                                var treeItem = emailSystemActionSelf.treeService.createTreeItemFromConfig(emailSystemActionSelf.currentTreeItem, () => {
                                    treeItem.emailBinding = emailSystemActionSelf.selectedEmailConfiguration;
                                    emailSystemActionSelf.selectedEmailConfiguration.bindings.push(treeItem);
                                    emailSystemActionSelf.saveChanges(() => {
                                        editor.insertContent("<span class='mceNonEditable fieldBind' data-TreeId=" + treeItem.id + ">" + emailSystemActionSelf.treeService.getDisplayName(treeItem) + "</span>");
                                    });
                                });
                            }
                        }
                    });

                    editor.addButton('destinationLink', {
                        text: 'Future Status/State',
                        type: 'menubutton',
                        icon: false,
                        menu: [
                            {
                                text: 'Destination Status',
                                onclick() {
                                    editor.insertContent('{{DestinationStatus}}');
                                }
                            },
                            {
                                text: 'Destination State',
                                onclick() {
                                    editor.insertContent('{{DestinationState}}');
                                }
                            }
                        ]
                    });

                    services.WarsLogger.logDebug("Editor Object", this.logType, editor);
                }
            };

            this.documentTags = [];
            this.recipientTags = [];
            this.carbonCopyTags = [];
            this.blindCarbonCopiesTags = [];
        }

        public addEmail() {
            this.documentTags = [];
            this.recipientTags = [];
            this.carbonCopyTags = [];
            this.blindCarbonCopiesTags = [];

            var newEmail = this.emailConfigurationService.createEmailConfiguration();
            if (this.processConfigurationId) {
                newEmail.processConfiguration_id = this.processConfigurationId;
            } else {
                newEmail.systemLevel_id = this.systemLevel.id;
                newEmail.mySystemLevel = this.systemLevel;
            }
            newEmail.uniqueIdentifier = services.UtilityService.generateGuidComb();
            this.saveChanges(() => {
                this.emailConfigurations.push(newEmail);
                this.selectedEmailConfiguration = newEmail;
                this.isEditing = true;
                this.editingNew = true;
                this.editingExisting = false;
            });
        }

        private pushTags(tags: any, treeItem: Wars.Domain.Model.TreeItem) {
            if (!treeItem.isClaimWithValue) {
                if (treeItem.claim !== null) {
                    tags.push({ id: treeItem.id, text: treeItem.claim.type });
                }
                else {
                    tags.push({ id: treeItem.id, text: this.treeService.getDisplayName(treeItem) });
                }
            } else {
                if (treeItem.constantValue_id) {
                    tags.push({ id: treeItem.id, text: treeItem.claim.type + '-' + treeItem.constantValue.name }); 
                } else if (treeItem.calculation_id) {
                    tags.push({ id: treeItem.id, text: treeItem.claim.type + '-' + treeItem.calculation.name });
                } else if (treeItem.queryConfiguration_id) {
                    tags.push({ id: treeItem.id, text: treeItem.claim.type + '-' + treeItem.queryConfiguration.name });
                } else if (treeItem.schemaProperty_id) {
                    tags.push({ id: treeItem.id, text: treeItem.claim.type + '-' + treeItem.schemaProperty.name });
                }
            }
        }

        private createDocumentTags(treeItem: Wars.Domain.Model.TreeItem) {
            if (treeItem.staticDocument_id !== null) {
                this.documentTags.push({ id: treeItem.id, text: treeItem.staticDocument.name });
            } else if (treeItem.schemaProperty_id !== null) {
                this.documentTags.push({ id: treeItem.id, text: treeItem.schemaProperty.name });
            }
        }

        public configureEmail(emailConfig: Wars.Domain.Model.EmailConfiguration) {
            this.isEditing = true;
            this.editingExisting = true;
            this.editingNew = false;
            this.selectedEmailConfiguration = emailConfig;
            this.documentTags = [];
            this.recipientTags = [];
            this.carbonCopyTags = [];
            this.blindCarbonCopiesTags = [];

            emailConfig.documents.forEach(d => {
                this.createDocumentTags(d);
            });
            emailConfig.recipients.forEach(r => {
                this.pushTags(this.recipientTags, r);
            });
            emailConfig.carbonCopies.forEach(c => {
                this.pushTags(this.carbonCopyTags, c);
            });
            emailConfig.blindCarbonCopies.forEach(b => {
                this.pushTags(this.blindCarbonCopiesTags, b);
            });
        }

        public deleteEmail(emailConfig: Wars.Domain.Model.EmailConfiguration): void {
            this.deleteService.deleteWithModalConfirmationIfNecessary(
                "EmailConfiguration",
                emailConfig.id,
                "Email Configuration Successfully Deleted",
                () => {
                    if (emailConfig.id === this.selectedEmailConfiguration.id) {
                        this.isEditing = false;
                    }
                    this.emailConfigurations.remove(emailConfig);
                },
                "Email Configuration Could not be Deleted");
        }

        public close() {
            this.isEditing = false;
            this.editingNew = false;
            this.editingExisting = false;
        }

        public getSelectedNode(data: models.TreeConfigurationItem) {
            console.info(data);
            emailSystemActionSelf.currentTreeItem = data;
        }

        public saveChanges(callback: () => void) {
            this.emailConfigurationService.saveAllChanges(callback);
        }

        public onDropAttachmentTreeItem($event) {
            var droppedTreeItem = this.treeService.getTreeConfigurationItem();
            if (!droppedTreeItem.staticDocumentId && !droppedTreeItem.schemaPropertyId) {
                emailSystemActionSelf.growlService.error("This item is not valid for this drop zone.");
                return;
            }
            //TODO - Kevin look inside the create tree item and modify where I am wiring up static doc id to also look at schema property id
            var treeItem = this.treeService.createTreeItemFromItemDropped();
            treeItem.emailConfiguration_id = this.selectedEmailConfiguration.id;
            treeItem.emailConfiguration = this.selectedEmailConfiguration;
            treeItem.variableType = Wars.Domain.Model.Codes.Enums.VariableType.Document;

            this.selectedEmailConfiguration.documents.push(treeItem);
            this.saveChanges(null);

            this.createDocumentTags(treeItem);
        }

        public onDropEmailRecipientToTreeItem($event) {
            var droppedTreeItem = this.treeService.getTreeConfigurationItem();
            if (droppedTreeItem.variableType !== Wars.Domain.Model.Codes.Enums.VariableType.User &&
                !droppedTreeItem.claimId &&
                !droppedTreeItem.emailGroupId &&
                !droppedTreeItem.claimGroupId &&
                !droppedTreeItem.schemaPropertyId &&
                !droppedTreeItem.relatedClaimProcessTypeId) {
                emailSystemActionSelf.growlService.error("This item is not valid for this drop zone.");
                return;
            }
            if (!droppedTreeItem.isClaimWithValue) {
                var treeItem = this.treeService.createTreeItemFromItemDropped();
                treeItem.emailRecipient_id = this.selectedEmailConfiguration.id;
                treeItem.emailRecipient = this.selectedEmailConfiguration;

                this.selectedEmailConfiguration.recipients.push(treeItem);
                if (treeItem.claim !== null) {
                    this.recipientTags.push({ id: treeItem.id, text: treeItem.claim.type });
                }
                else if (treeItem.emailGroup !== null) {
                    this.recipientTags.push({ id: treeItem.id, text: this.treeService.getDisplayName(treeItem) });
                }
                else if (treeItem.variableType === Wars.Domain.Model.Codes.Enums.VariableType.User) {
                    this.recipientTags.push({ id: treeItem.id, text: this.treeService.getDisplayName(treeItem) });
                }
                else if (treeItem.claimGroup !== null) {
                    this.recipientTags.push({ id: treeItem.id, text: this.treeService.getDisplayName(treeItem) });
                }
                else if (treeItem.schemaProperty !== null) {
                    this.recipientTags.push({ id: treeItem.id, text: this.treeService.getDisplayName(treeItem) });
                }
                else if (treeItem.relatedClaimProcessType_id !== null) {
                    this.recipientTags.push({ id: treeItem.id, text: this.treeService.getDisplayName(treeItem) });
                }
                this.saveChanges(null);
            } else {
                this.recipient = droppedTreeItem;
            }
        }

        public onDropEmailRecipientValueToTreeItem($event) {
            var droppedTreeItem = this.treeService.getTreeConfigurationItem();

            if (!(droppedTreeItem.variableType === Wars.Domain.Model.Codes.Enums.VariableType.Code
                || droppedTreeItem.variableType === Wars.Domain.Model.Codes.Enums.VariableType.String
                || droppedTreeItem.variableType === Wars.Domain.Model.Codes.Enums.VariableType.Integer)) {
                emailSystemActionSelf.growlService.error("This item is not valid for this drop zone.");
                return;
            }

            var claimTreeItem = this.treeService.createTreeItemFromConfig(this.recipient);
            claimTreeItem.emailRecipient_id = this.selectedEmailConfiguration.id;
            claimTreeItem.emailRecipient = this.selectedEmailConfiguration;

            if (droppedTreeItem.constantId) {
                claimTreeItem.constantValue_id = droppedTreeItem.constantId;
                this.recipientTags.push({ id: claimTreeItem.id, text: claimTreeItem.claim.type + '-' + claimTreeItem.constantValue.name });
            } else if (droppedTreeItem.calculationId) {
                claimTreeItem.calculation_id = droppedTreeItem.calculationId;
                this.recipientTags.push({ id: claimTreeItem.id, text: claimTreeItem.claim.type + '-' + claimTreeItem.calculation.name });
            } else if (droppedTreeItem.queryId) {
                claimTreeItem.queryConfiguration_id = droppedTreeItem.queryId;
                this.recipientTags.push({ id: claimTreeItem.id, text: claimTreeItem.claim.type + '-' + claimTreeItem.queryConfiguration.name });
            } else if (droppedTreeItem.schemaPropertyId) {
                claimTreeItem.schemaProperty_id = droppedTreeItem.schemaPropertyId;
                this.recipientTags.push({ id: claimTreeItem.id, text: claimTreeItem.claim.type + '-' + claimTreeItem.schemaProperty.name });
            }
            claimTreeItem.claimWithValueIsSystemLevel = droppedTreeItem.isSystemLevel;
            this.selectedEmailConfiguration.recipients.push(claimTreeItem);
            this.recipient = null;
            this.saveChanges(null);
        }

        public onDropEmailCarbonCopyToTreeItem($event) {
            var droppedTreeItem = this.treeService.getTreeConfigurationItem();
            if (droppedTreeItem.variableType !== Wars.Domain.Model.Codes.Enums.VariableType.User &&
                !droppedTreeItem.claimId &&
                !droppedTreeItem.emailGroupId &&
                !droppedTreeItem.claimGroupId &&
                !droppedTreeItem.schemaPropertyId &&
                !droppedTreeItem.relatedClaimProcessTypeId)
            {
                emailSystemActionSelf.growlService.error("This item is not valid for this drop zone.");
                return;
            }
            if (!droppedTreeItem.isClaimWithValue) {
                var treeItem = this.treeService.createTreeItemFromItemDropped();
                treeItem.emailCarbonCopy_id = this.selectedEmailConfiguration.id;
                treeItem.emailCarbonCopy = this.selectedEmailConfiguration;

                this.selectedEmailConfiguration.carbonCopies.push(treeItem);

                if (treeItem.claim !== null) {
                    this.carbonCopyTags.push({ id: treeItem.id, text: treeItem.claim.type });
                } else if (treeItem.emailGroup !== null) {
                    this.carbonCopyTags.push({ id: treeItem.id, text: this.treeService.getDisplayName(treeItem) });
                }
                else if (treeItem.variableType === Wars.Domain.Model.Codes.Enums.VariableType.User) {
                    this.carbonCopyTags.push({ id: treeItem.id, text: this.treeService.getDisplayName(treeItem) });
                }
                else if (treeItem.claimGroup !== null) {
                    this.carbonCopyTags.push({ id: treeItem.id, text: this.treeService.getDisplayName(treeItem) });
                }
                else if (treeItem.schemaProperty !== null) {
                    this.carbonCopyTags.push({ id: treeItem.id, text: this.treeService.getDisplayName(treeItem) });
                }
                else if (treeItem.relatedClaimProcessType_id !== null) {
                    this.carbonCopyTags.push({ id: treeItem.id, text: this.treeService.getDisplayName(treeItem) });
                }
                this.saveChanges(null);
            } else {
                this.carbonCopy = droppedTreeItem;
            }
        }

        public onDropEmailCarbonCopyValueToTreeItem($event) {
            var droppedTreeItem = this.treeService.getTreeConfigurationItem();

            if (!(droppedTreeItem.variableType === Wars.Domain.Model.Codes.Enums.VariableType.Code
                || droppedTreeItem.variableType === Wars.Domain.Model.Codes.Enums.VariableType.String
                || droppedTreeItem.variableType === Wars.Domain.Model.Codes.Enums.VariableType.Integer)) {
                emailSystemActionSelf.growlService.error("This item is not valid for this drop zone.");
                return;
            }

            var claimTreeItem = this.treeService.createTreeItemFromConfig(this.carbonCopy);
            claimTreeItem.emailCarbonCopy_id = this.selectedEmailConfiguration.id;
            claimTreeItem.emailCarbonCopy = this.selectedEmailConfiguration;

            if (droppedTreeItem.constantId) {
                claimTreeItem.constantValue_id = droppedTreeItem.constantId;
                this.carbonCopyTags.push({ id: claimTreeItem.id, text: claimTreeItem.claim.type + '-' + claimTreeItem.constantValue.name });
            } else if (droppedTreeItem.calculationId) {
                claimTreeItem.calculation_id = droppedTreeItem.calculationId;
                this.carbonCopyTags.push({ id: claimTreeItem.id, text: claimTreeItem.claim.type + '-' + claimTreeItem.calculation.name });
            } else if (droppedTreeItem.queryId) {
                claimTreeItem.queryConfiguration_id = droppedTreeItem.queryId;
                this.carbonCopyTags.push({ id: claimTreeItem.id, text: claimTreeItem.claim.type + '-' + claimTreeItem.queryConfiguration.name });
            } else if (droppedTreeItem.schemaPropertyId) {
                claimTreeItem.schemaProperty_id = droppedTreeItem.schemaPropertyId;
                this.carbonCopyTags.push({ id: claimTreeItem.id, text: claimTreeItem.claim.type + '-' + claimTreeItem.schemaProperty.name });
            }
            claimTreeItem.claimWithValueIsSystemLevel = droppedTreeItem.isSystemLevel;
            this.selectedEmailConfiguration.carbonCopies.push(claimTreeItem);
            this.carbonCopy = null;
            this.saveChanges(null);
        }

        public onDropEmailBlindCarbonCopyToTreeItem($event) {
            var droppedTreeItem = this.treeService.getTreeConfigurationItem();
            if (droppedTreeItem.variableType !== Wars.Domain.Model.Codes.Enums.VariableType.User &&
                !droppedTreeItem.claimId &&
                !droppedTreeItem.emailGroupId &&
                !droppedTreeItem.claimGroupId &&
                !droppedTreeItem.relatedClaimProcessTypeId)
            {
                emailSystemActionSelf.growlService.error("This item is not valid for this drop zone.");
                return;
            }
            if (!droppedTreeItem.isClaimWithValue) {
                var treeItem = this.treeService.createTreeItemFromItemDropped();
                treeItem.emailBlindCarbonCopy_id = this.selectedEmailConfiguration.id;
                treeItem.emailBlindCarbonCopy = this.selectedEmailConfiguration;

                this.selectedEmailConfiguration.blindCarbonCopies.push(treeItem);
                if (treeItem.claim !== null) {
                    this.blindCarbonCopiesTags.push({ id: treeItem.id, text: treeItem.claim.type });
                } else if (treeItem.emailGroup !== null) {
                    this.blindCarbonCopiesTags.push({ id: treeItem.id, text: this.treeService.getDisplayName(treeItem) });
                }
                else if (treeItem.variableType === Wars.Domain.Model.Codes.Enums.VariableType.User) {
                    this.blindCarbonCopiesTags.push({ id: treeItem.id, text: this.treeService.getDisplayName(treeItem) });
                }
                else if (treeItem.claimGroup !== null) {
                    this.blindCarbonCopiesTags.push({ id: treeItem.id, text: this.treeService.getDisplayName(treeItem) });
                }
                else if (treeItem.schemaProperty !== null) {
                    this.blindCarbonCopiesTags.push({ id: treeItem.id, text: this.treeService.getDisplayName(treeItem) });
                }
                else if (treeItem.relatedClaimProcessType_id !== null) {
                    this.blindCarbonCopiesTags.push({ id: treeItem.id, text: this.treeService.getDisplayName(treeItem) });
                }
                this.saveChanges(null);
            } else {
                this.blindCarbonCopy = droppedTreeItem;
            }
        }

        public onDropEmailBlindCarbonCopyValueToTreeItem($event) {
            var droppedTreeItem = this.treeService.getTreeConfigurationItem();

            if (!(droppedTreeItem.variableType === Wars.Domain.Model.Codes.Enums.VariableType.Code
                || droppedTreeItem.variableType === Wars.Domain.Model.Codes.Enums.VariableType.String
                || droppedTreeItem.variableType === Wars.Domain.Model.Codes.Enums.VariableType.Integer)) {
                emailSystemActionSelf.growlService.error("This item is not valid for this drop zone.");
                return;
            }

            var claimTreeItem = this.treeService.createTreeItemFromConfig(this.blindCarbonCopy);
            claimTreeItem.emailBlindCarbonCopy_id = this.selectedEmailConfiguration.id;
            claimTreeItem.emailBlindCarbonCopy = this.selectedEmailConfiguration;

            if (droppedTreeItem.constantId) {
                claimTreeItem.constantValue_id = droppedTreeItem.constantId;
                this.blindCarbonCopiesTags.push({ id: claimTreeItem.id, text: claimTreeItem.claim.type + '-' + claimTreeItem.constantValue.name });
            } else if (droppedTreeItem.calculationId) {
                claimTreeItem.calculation_id = droppedTreeItem.calculationId;
                this.blindCarbonCopiesTags.push({ id: claimTreeItem.id, text: claimTreeItem.claim.type + '-' + claimTreeItem.calculation.name });
            } else if (droppedTreeItem.queryId) {
                claimTreeItem.queryConfiguration_id = droppedTreeItem.queryId;
                this.blindCarbonCopiesTags.push({ id: claimTreeItem.id, text: claimTreeItem.claim.type + '-' + claimTreeItem.queryConfiguration.name });
            } else if (droppedTreeItem.schemaPropertyId) {
                claimTreeItem.schemaProperty_id = droppedTreeItem.schemaPropertyId;
                this.blindCarbonCopiesTags.push({ id: claimTreeItem.id, text: claimTreeItem.claim.type + '-' + claimTreeItem.schemaProperty.name });
            } else if (droppedTreeItem.claimGroupId) {
                claimTreeItem.claimGroup_id = droppedTreeItem.claimGroupId;
                this.recipientTags.push({ id: claimTreeItem.id, text: claimTreeItem.claim.type + '-' + claimTreeItem.claimGroup.name });
            }
            claimTreeItem.claimWithValueIsSystemLevel = droppedTreeItem.isSystemLevel;
            this.selectedEmailConfiguration.blindCarbonCopies.push(claimTreeItem);
            this.blindCarbonCopy = null;
            this.saveChanges(null);
        }

        public removeRecipient(tag) {
            this.selectedEmailConfiguration.recipients.forEach(r => {
                if (r.id === tag.id) {
                    r.entityAspect.setDeleted();
                    this.saveChanges(null);
                }
            });
        }

        public removeCarbonCarbonCopy(tag) {
            this.selectedEmailConfiguration.carbonCopies.forEach(c => {
                if (c.id === tag.id) {
                    c.entityAspect.setDeleted();
                    this.saveChanges(null);
                }
            });
        }

        public removeBlindCarbonCopy(tag) {
            this.selectedEmailConfiguration.blindCarbonCopies.forEach(b => {
                if (b.id === tag.id) {
                    b.entityAspect.setDeleted();
                    this.saveChanges(null);
                }
            });
        }

        public removeDocument(tag) {
            this.selectedEmailConfiguration.documents.forEach(d => {
                if (d.id === tag.id) {
                    d.entityAspect.setDeleted();
                    this.saveChanges(null);
                }
            });
        }

        public removeEmailRecipient(emailRecipient) {
            emailRecipient.entityAspect.setDeleted();
            this.saveChanges(null);
        }
    }
}